<template lang="pug">
AppPopover(
  trigger="hover"
  extra-popover-classes="remote-task-popover"
  placement="top"
)
  span(slot="body")
    a(
      target="_blank"
      rel="noopener noreferrer"
      :href="taskUrl"
    )
      | {{ taskDescription }}
      i.fa.fa-external-link.ml-5
  span(slot="trigger")
    slot
</template>

<script>
export default {
  name: 'TimeAndActivitiesReportTaskPopover',
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    taskRemoteId() {
      return this.record.t_remote_alternate_id || this.record.t_remote_id;
    },
    taskDescription() {
      return `Remote ID: ${this.taskRemoteId}`;
    },
    taskUrl() {
      return `/tasks/${this.record.t_id}/redirect`;
    },
  },
};
</script>
